import React from 'react'
import { ValFormReg } from '../../../Validators/ValForms';
import { RegularExpressions } from '../../../Helpers/RegularExpression';


export const ValTasaInteres = (state) => {
    // const nuevousado = ValForm("Nuevo o Usado", state.nuevousado);
    const descripcion = ValFormReg(
        "DESCRIPCION",
        state.descripcion,
        RegularExpressions.TextWithSpace
    );
    
    var isValid = true;
    var mensaje = "";
    if (descripcion.isValid === false) {
        state.bdescripcion = true;
        isValid = false;
        mensaje += descripcion.mensaje;
    }
    if (isValid === false) {
        return { isValid, state, mensaje };
    } else {
        return {
            isValid,
            post: {
                idtipo_tasa:0,
                descripcion:state.descripcion,
                fecha_inicio:"",
                fecha_fin:"",
                documento:"",
                extension:""
            },
        };
    }
};


